import React,{ useState, useEffect,useRef} from "react";
import {Select,message} from "antd";

interface searchElementProps 
{
    style:any;
    diagrams:any;
    searchElementChange:(newSearchElement,newSelectType) => void;
}

const searchElement: React.FC<searchElementProps> = ({style,diagrams,searchElementChange}) => 
{
    const [messageApi, contextHolder] = message.useMessage();
    const defaultOptions = 
    [
        {
            label:<span>设备</span>,
            title:"设备",
            options:[],
        },
        {
            label:<span>流股</span>,
            title:"流股",
            options:[],
        },
    ]
    const [options,setOptions] = useState(defaultOptions);

    const queryNewData = ()=>
    {
        if(diagrams)
        {
            const model = diagrams.model;
            const nodeDataArray = model.nodeDataArray;
            const linkDataArray = model.linkDataArray;

            let nodeOptions = [];
            for(let i=0;i<nodeDataArray.length;i++)
            {
                let nodeName = nodeDataArray[i].nodeName;
                if(nodeName && (!nodeDataArray[i].isGroup))
                {
                    let nodeOption = {label:nodeName,value:nodeName,type:"node"};
                    nodeOptions.push(nodeOption);
                }
            }

            let linkOptions = [];
            for(let i=0;i<linkDataArray.length;i++)
            {
                let linkName = linkDataArray[i].linkName;
                if(linkName)
                {
                    let linkOption = {label:linkName,value:linkName,type:"link"};
                    linkOptions.push(linkOption);
                }
            }

            let newOptions =
            [
                {
                    label:<span>设备</span>,
                    title:"设备",
                    options:nodeOptions,
                },
                {
                    label:<span>流股</span>,
                    title:"流股",
                    options:linkOptions,
                },
            ]
            
            setOptions(newOptions);
        }
    }

    return (
        <>
        {contextHolder}
        <div>
            <Select
                onChange={(selectedValue,e) => 
                {
                    let selectName = e["value"];
                    let selectType = e["type"];
                    searchElementChange(selectName,selectType);
                }}
                style={style}
                onOpenChange={(open) => open && queryNewData()}
                options={options}
                showSearch
            />
        </div>
        </>
    );
};

export default searchElement;